import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        forms: '=',
        courses: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'survey.Export results as CSV' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-warn">
                {{ 'survey.Exported CSV may contain data from surveys that have not yet been completed by all participants' | translate }}
            </div>
            <form class="form">
                <alert-error ng-if="vm.errors.formIds">{{ vm.errors.formIds }}</alert-error>
                <alert-error ng-if="vm.errors.courseIds">{{ vm.errors.courseIds }}</alert-error>
                <form-row error="vm.errors.formIds">
                    <label class="label">{{ 'survey.Form' | translate }}</label>
                    <div class="items">
                        <div
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.forms.options"
                            selected-model="vm.multiFilter.forms.model"
                            events="vm.multiFilter.forms.events"
                            extra-settings="vm.multiFilter.settings"
                            ng-click="vm.updateCourses()"
                            translation-texts="vm.multiFilter.translations"
                            >
                        </div>
                    </div>
                </form-row>
                <form-row error="vm.errors.formIds">
                    <label class="label">{{ 'survey.Course' | translate }}</label>
                    <div class="items">
                        <div
                            ng-if="vm.toggleCourse"
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.courses.options"
                            selected-model="vm.multiFilter.courses.model"
                            extra-settings="vm.multiFilter.settings"
                            translation-texts="vm.multiFilter.translations"
                        ></div>
                        <div
                            ng-if="!vm.toggleCourse"
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.courses.options"
                            selected-model="vm.multiFilter.courses.model"
                            extra-settings="vm.multiFilter.settings"
                            translation-texts="vm.multiFilter.translations"
                        ></div>
                    </div>
                </form-row>
            </form>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary">
                    <div ng-if="!vm.enableDownloadButton()" class="btn main disabled">{{ 'general.Export results as CSV' | translate }}</div>
                    <button ng-if="vm.enableDownloadButton()" class="btn main" type="button" ng-click="vm.export()">
                        {{ 'general.Export results as CSV' | translate }}
                    </button>
                </li>
                <li class="primary">
                    <button ng-if="vm.enableDownloadButton()" class="btn bordered02" type="button" ng-click="vm.reset()">
                        {{ 'general.Reset' | translate }}
                    </button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $window, lodash, AuthResource) {
        this.$translate = $translate;
        this.$window = $window;
        this.lodash = lodash;
        this.AuthResource = AuthResource;
    }

    $onInit () {
        this.initMultiFilter();
    }

    initMultiFilter () {
        const formOptions = this.forms.map(form => {
            return {
                value: form.id,
                label: form.activeI18n.name
            };
        });
        const courseOptions = this.courses.map(course => {
            return {
                value: course.id,
                label: course.activeI18n.name
            };
        });

        this.multiFilter = {
            forms: {
                model: [],
                options: formOptions,
                events: {
                    onSelectionChanged: () => {
                        const selectedFormIds = this.multiFilter.forms.model.map(item => item.value);
                        let validCourses = this.courses;
                        if (selectedFormIds.length) {
                            validCourses = this.courses.filter(course => {
                                return this.lodash.some(
                                    course.feedbackTrainings.map(item => item.formId),
                                    item => this.lodash.includes(selectedFormIds, item)
                                );
                            });
                        }
                        this.multiFilter.courses.options = validCourses.map(course => {
                            return {
                                value: course.id,
                                label: course.activeI18n.name
                            };
                        });
                        this.multiFilter.courses.model = this.multiFilter.courses.options.filter(course => {
                            return this.lodash.some(this.multiFilter.courses.model, item => item.value === course.value);
                        });
                        this.toggleCourse = !this.toggleCourse;
                    }
                }
            },
            courses: {
                model: [],
                options: courseOptions
            },
            settings: {
                enableSearch: true,
                checkBoxes: true,
                showCheckAll: false,
                showUncheckAll: false,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: itemText => itemText
            },
            translations: {
                buttonDefaultText: this.$translate.instant('filter.Select'),
                searchPlaceholder: this.$translate.instant('general.Search')
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    enableDownloadButton () {
        return this.multiFilter.forms.model.length || this.multiFilter.courses.model.length;
    }

    export () {
        this.AuthResource
            .requestTacToken()
            .$promise
            .then(({ token }) => {
                const formParams = this.multiFilter.forms.model.map(form => {
                    return `formIds[]=${form.value}`;
                }).join('&');
                const courseParams = this.multiFilter.courses.model.map(course => {
                    return `courseIds[]=${course.value}`;
                }).join('&');
                const url = `${SEED_CORE.ENV.API_URL}survey/survey-group/export-results/?tacToken=${token}&${formParams}&${courseParams}`;
                this.$window.open(url);
            });
    }

    reset () {
        this.multiFilter = angular.copy(this.defaultMultiFilter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/survey/export/index.js